export type CategoryBreadcrumb = {
    title: string;
    id: string;
    depth: number;
};

type RawCategoryBreadcrumb = Omit<CategoryBreadcrumb, 'title'> & { title?: string };

export function safeParseBreadcrumbs(value: string | null | undefined): CategoryBreadcrumb[] | undefined {
    try {
        if (!value) {
            return undefined;
        }
        const parsed = JSON.parse(value) as RawCategoryBreadcrumb[];
        return parsed.map((b) => ({ ...b, title: b.title ?? '' }));
    } catch {
        return undefined;
    }
}
